
// Country Data
export const countriesData = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, Democratic Republic of the' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GR', label: 'Greece' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KR', label: 'Korea, Republic of' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Lao People\'s Democratic Republic' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MK', label: 'Macedonia' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' }
];



// Currency Data
export const currencyData = [
  { value: "AED", label: "United Arab Emirates dirham (د.إ)" },
  { value: "AFN", label: "Afghan afghani (؋)" },
  { value: "ALL", label: "Albanian lek (L)" },
  { value: "AMD", label: "Armenian dram (AMD)" },
  { value: "ANG", label: "Netherlands Antillean guilder (ƒ)" },
  { value: "AOA", label: "Angolan kwanza (Kz)" },
  { value: "ARS", label: "Argentine peso ($)" },
  { value: "AUD", label: "Australian dollar ($)" },
  { value: "AWG", label: "Aruban florin (Afl.)" },
  { value: "AZN", label: "Azerbaijani manat (AZN)" },
  { value: "BAM", label: "Bosnia and Herzegovina convertible mark (KM)" },
  { value: "BBD", label: "Barbadian dollar ($)" },
  { value: "BDT", label: "Bangladeshi taka (৳)" },
  { value: "BGN", label: "Bulgarian lev (лв.)" },
  { value: "BHD", label: "Bahraini dinar (.د.ب)" },
  { value: "BIF", label: "Burundian franc (Fr)" },
  { value: "BMD", label: "Bermudian dollar ($)" },
  { value: "BND", label: "Brunei dollar ($)" },
  { value: "BOB", label: "Bolivian boliviano (Bs.)" },
  { value: "BRL", label: "Brazilian real (R$)" },
  { value: "BSD", label: "Bahamian dollar ($)" },
  { value: "BTC", label: "Bitcoin (฿)" },
  { value: "BTN", label: "Bhutanese ngultrum (Nu.)" },
  { value: "BWP", label: "Botswana pula (P)" },
  { value: "BYR", label: "Belarusian ruble (old) (Br)" },
  { value: "BYN", label: "Belarusian ruble (Br)" },
  { value: "BZD", label: "Belize dollar ($)" },
  { value: "CAD", label: "Canadian dollar ($)" },
  { value: "CDF", label: "Congolese franc (Fr)" },
  { value: "CHF", label: "Swiss franc (CHF)" },
  { value: "CLP", label: "Chilean peso ($)" },
  { value: "CNY", label: "Chinese yuan (¥)" },
  { value: "COP", label: "Colombian peso ($)" },
  { value: "CRC", label: "Costa Rican colón (₡)" },
  { value: "CUC", label: "Cuban convertible peso ($)" },
  { value: "CUP", label: "Cuban peso ($)" },
  { value: "CVE", label: "Cape Verdean escudo ($)" },
  { value: "CZK", label: "Czech koruna (Kč)" },
  { value: "DJF", label: "Djiboutian franc (Fr)" },
  { value: "DKK", label: "Danish krone (DKK)" },
  { value: "DOP", label: "Dominican peso (RD$)" },
  { value: "DZD", label: "Algerian dinar (د.ج)" },
  { value: "EGP", label: "Egyptian pound (EGP)" },
  { value: "ERN", label: "Eritrean nakfa (Nfk)" },
  { value: "ETB", label: "Ethiopian birr (Br)" },
  { value: "EUR", label: "Euro (€)" },
  { value: "FJD", label: "Fijian dollar ($)" },
  { value: "FKP", label: "Falkland Islands pound (£)" },
  { value: "GBP", label: "Pound sterling (£)" },
  { value: "GEL", label: "Georgian lari (ლ)" },
  { value: "GGP", label: "Guernsey pound (£)" },
  { value: "GHS", label: "Ghana cedi (₵)" },
  { value: "GIP", label: "Gibraltar pound (£)" },
  { value: "GMD", label: "Gambian dalasi (D)" },
  { value: "GNF", label: "Guinean franc (Fr)" },
  { value: "GTQ", label: "Guatemalan quetzal (Q)" },
  { value: "GYD", label: "Guyanese dollar ($)" },
  { value: "HKD", label: "Hong Kong dollar (HK$)" },
  { value: "HNL", label: "Honduran lempira (L)" },
  { value: "HRK", label: "Croatian kuna (Kn)" },
  { value: "HTG", label: "Haitian gourde (G)" },
  { value: "HUF", label: "Hungarian forint (Ft)" },
  { value: "IDR", label: "Indonesian rupiah (Rp)" },
  { value: "ILS", label: "Israeli new shekel (₪)" },
  { value: "IMP", label: "Manx pound (£)" },
  { value: "INR", label: "Indian rupee (₹)" },
  { value: "IQD", label: "Iraqi dinar (ع.د)" },
  { value: "IRR", label: "Iranian rial (﷼)" },
  { value: "IRT", label: "Iranian toman (تومان)" },
  { value: "ISK", label: "Icelandic króna (kr.)" },
  { value: "JEP", label: "Jersey pound (£)" },
  { value: "JMD", label: "Jamaican dollar ($)" },
  { value: "JOD", label: "Jordanian dinar (د.ا)" },
  { value: "JPY", label: "Japanese yen (¥)" },
  { value: "KES", label: "Kenyan shilling (KSh)" },
  { value: "KGS", label: "Kyrgyzstani som (сом)" },
  { value: "KHR", label: "Cambodian riel (៛)" },
  { value: "KMF", label: "Comorian franc (Fr)" },
  { value: "KPW", label: "North Korean won (₩)" },
  { value: "KRW", label: "South Korean won (₩)" },
  { value: "KWD", label: "Kuwaiti dinar (د.ك)" },
  { value: "KYD", label: "Cayman Islands dollar ($)" },
  { value: "KZT", label: "Kazakhstani tenge (KZT)" },
  { value: "LAK", label: "Lao kip (₭)" },
  { value: "LBP", label: "Lebanese pound (ل.ل)" },
  { value: "LKR", label: "Sri Lankan rupee (රු)" },
  { value: "LRD", label: "Liberian dollar ($)" },
  { value: "LSL", label: "Lesotho loti (L)" },
  { value: "LYD", label: "Libyan dinar (ل.د)" },
  { value: "MAD", label: "Moroccan dirham (د.م.)" },
  { value: "MDL", label: "Moldovan leu (MDL)" },
  { value: "MGA", label: "Malagasy ariary (Ar)" },
  { value: "MKD", label: "Macedonian denar (ден)" },
  { value: "MMK", label: "Burmese kyat (Ks)" },
  { value: "MNT", label: "Mongolian tögrög (₮)" },
  { value: "MOP", label: "Macanese pataca (MOP$)" },
  { value: "MRO", label: "Mauritanian ouguiya (UM)" },
  { value: "MUR", label: "Mauritian rupee (₨)" },
  { value: "MVR", label: "Maldivian rufiyaa (.ރ)" },
  { value: "MWK", label: "Malawian kwacha (MK)" },
  { value: "MXN", label: "Mexican peso ($)" },
  { value: "MYR", label: "Malaysian ringgit (RM)" },
  { value: "MZN", label: "Mozambican metical (MT)" },
  { value: "NAD", label: "Namibian dollar (N$)" },
  { value: "NGN", label: "Nigerian naira (₦)" },
  { value: "NIO", label: "Nicaraguan córdoba (C$)" },
  { value: "NOK", label: "Norwegian krone (kr)" },
  { value: "NPR", label: "Nepalese rupee (₨)" },
  { value: "NZD", label: "New Zealand dollar ($)" },
  { value: "OMR", label: "Omani rial (ر.ع.)" },
  { value: "PAB", label: "Panamanian balboa (B/.)" },
  { value: "PEN", label: "Peruvian nuevo sol (S/.)" },
  { value: "PGK", label: "Papua New Guinean kina (K)" },
  { value: "PHP", label: "Philippine peso (₱)" },
  { value: "PKR", label: "Pakistani rupee (₨)" },
  { value: "PLN", label: "Polish złoty (zł)" },
  { value: "PRB", label: "Transnistrian ruble (р.)" },
  { value: "PYG", label: "Paraguayan guaraní (₲)" },
  { value: "QAR", label: "Qatari riyal (ر.ق)" },
  { value: "RON", label: "Romanian leu (lei)" },
  { value: "RSD", label: "Serbian dinar (дин.)" },
  { value: "RUB", label: "Russian ruble (₽)" },
  { value: "RWF", label: "Rwandan franc (Fr)" },
  { value: "SAR", label: "Saudi riyal (ر.س)" },
  { value: "SBD", label: "Solomon Islands dollar ($)" },
  { value: "SCR", label: "Seychellois rupee (₨)" },
  { value: "SDG", label: "Sudanese pound (ج.س.)" },
  { value: "SEK", label: "Swedish krona (kr)" },
  { value: "SGD", label: "Singapore dollar ($)" },
  { value: "SHP", label: "Saint Helena pound (£)" },
  { value: "SLL", label: "Sierra Leonean leone (Le)" },
  { value: "SOS", label: "Somali shilling (Sh)" },
  { value: "SRD", label: "Surinamese dollar ($)" },
  { value: "SSP", label: "South Sudanese pound (£)" },
  { value: "STD", label: "São Tomé and Príncipe dobra (Db)" },
  { value: "SYP", label: "Syrian pound (ل.س)" },
  { value: "SZL", label: "Swazi lilangeni (L)" },
  { value: "THB", label: "Thai baht (฿)" },
  { value: "TJS", label: "Tajikistani somoni (ЅМ)" },
  { value: "TMT", label: "Turkmenistan manat (m)" },
  { value: "TND", label: "Tunisian dinar (د.ت)" },
  { value: "TOP", label: "Tongan paʻanga (T$)" },
  { value: "TRY", label: "Turkish lira (₺)" },
  { value: "TTD", label: "Trinidad and Tobago dollar ($)" },
  { value: "TWD", label: "New Taiwan dollar (NT$)" },
  { value: "TZS", label: "Tanzanian shilling (Sh)" },
  { value: "UAH", label: "Ukrainian hryvnia (₴)" },
  { value: "UGX", label: "Ugandan shilling (UGX)" },
  { value: "USD", label: "United States dollar ($)" },
  { value: "UYU", label: "Uruguayan peso ($)" },
  { value: "UZS", label: "Uzbekistani som (UZS)" },
  { value: "VEF", label: "Venezuelan bolívar (Bs F)" },
  { value: "VND", label: "Vietnamese đồng (₫)" },
  { value: "VUV", label: "Vanuatu vatu (Vt)" },
  { value: "WST", label: "Samoan tālā (T)" },
  { value: "XAF", label: "Central African CFA franc (CFA)" },
  { value: "XCD", label: "East Caribbean dollar ($)" },
  { value: "XOF", label: "West African CFA franc (CFA)" },
  { value: "XPF", label: "CFP franc (Fr)" },
  { value: "YER", label: "Yemeni rial (﷼)" },
  { value: "ZAR", label: "South African rand (R)" },
  { value: "ZMW", label: "Zambian kwacha (ZK)" }
];